export default __webpack_public_path__ + "static/media/plus.1e0a98e2.svg";